import { type FC, MouseEvent } from 'react';
import { useTranslations } from 'next-intl';

import { useUpdateMerchant } from '@entities/merchant';
import { useUser } from '@entities/user';

import { AnalyticsEvent, useAnalytics } from '@shared/analytics';
import { useToast } from '@shared/hooks';
import { Button } from '@shared/ui-kit';

import { assignMerchant } from '../../api';

interface Props {
  merchantId: string;
  triggerUpdate: ReturnType<typeof useUpdateMerchant>['trigger'];
}

const AssignToMeButton: FC<Props> = (props) => {
  const { merchantId, triggerUpdate } = props;

  const { track } = useAnalytics();
  const t = useTranslations();
  const toast = useToast({ errorMessage: t('Toast.ErrorMessages.default') });
  const user = useUser();

  const onClick = async (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    track(AnalyticsEvent.AssignToMe);

    if (!user) return;

    await triggerUpdate({
      onError: () => toast('error'),
      callback: async () => {
        const merchant = await assignMerchant(merchantId, user.id);
        return merchant;
      },
    });
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      fontSize="sm"
      lineHeight="short"
      data-qa-selector="assign_to_me_button"
      data-testid="assign_to_me_button"
      m="0"
      onClick={onClick}
      _hover={{ textDecoration: 'underline' }}
    >
      {t('General.assignToMe')}
    </Button>
  );
};

export default AssignToMeButton;
